import React, { useState } from "react";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";

interface RejectSubmissionModalProps {
  open: boolean;
  onClose: () => void;
  handleReject: (submissionId: string, reason: string) => void;
  submissionId: string | null;
}

const RejectSubmissionModal: React.FC<RejectSubmissionModalProps> = ({
  open,
  onClose,
  handleReject,
  submissionId,
}) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (submissionId) {
      handleReject(submissionId, reason);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} sx={{ zIndex: 9999 }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "70%", md: "40%" },
          maxWidth: 500,
          borderRadius: 2,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: { xs: 3, sm: 4 },
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
          Raison du rejet
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Entrez la raison du rejet..."
          sx={{ mb: 3 }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "flex-end",
            gap: 2,
            mt: 3,
          }}
        >
          <Button
            onClick={onClose}
            color="secondary"
            variant="outlined"
            fullWidth={false}
            sx={{
              minWidth: { xs: "100%", sm: "auto" },
              order: { xs: 2, sm: 1 },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            fullWidth={false}
            sx={{
              backgroundColor: "#E3B505",
              color: "#000000",
              "&:hover": {
                backgroundColor: "#D1A305",
              },
              minWidth: { xs: "100%", sm: "auto" },
              order: { xs: 1, sm: 2 },
            }}
          >
            Rejeter
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RejectSubmissionModal;
